import React from 'react';
import { node, oneOf, oneOfType, string, bool, number, func } from 'prop-types';

import { LoaderAnimate } from '@/components/Loader';

import { BTN_SIZE_PROPS, BTN_VARIANT_PROPS } from '../constants';
import { styBtn } from '../style';
import Icon from '../features/Icon';

const BaseButton = (props) => {
  const {
    _type,
    children,
    className,
    disabled,
    fluid,
    loading,
    minWidth,
    onClick,
    size,
    tooltipTitle,
    variant,
    ...rest
  } = props;

  const styBtnProps = {
    fluid,
    minWidth,
    size,
    type: _type,
    variant,
  };

  const handleClick = (e) => {
    if (!loading && onClick) {
      onClick(e);
    }
  };

  return (
    <button
      className={`${styBtn(styBtnProps)} ${className}`}
      disabled={disabled}
      title={tooltipTitle}
      type="button"
      onClick={handleClick}
      data-toggle="tooltip"
      data-placement="top"
      {...rest}
    >
      {loading ? (
        <Icon size={size} icon={<LoaderAnimate className="loader" variant="white" />} />
      ) : (
        children
      )}
    </button>
  );
};

BaseButton.propTypes = {
  // Private props
  _type: oneOf(['text', 'text-icon', 'icon']),
  // Public props
  children: oneOfType([node, string]),
  className: string,
  disabled: bool,
  fluid: bool,
  loading: bool,
  minWidth: oneOfType([string, number]),
  onClick: func,
  size: oneOf(BTN_SIZE_PROPS),
  tooltipTitle: string,
  variant: oneOf(BTN_VARIANT_PROPS),
};

BaseButton.defaultProps = {
  // Private props
  _type: 'text',
  // Public props
  children: null,
  className: '',
  disabled: false,
  fluid: false,
  loading: false,
  minWidth: 82,
  onClick: () => {},
  size: 'sm',
  tooltipTitle: '',
  variant: 'primary',
};

export default BaseButton;
